const actions = {
  FETCH_COMPANIES: 'FETCH_COMPANIES',
  FETCH_COMPANIES_SUCCESS: 'FETCH_COMPANIES_SUCCESS',
  FETCH_COMPANIES_ERROR: 'FETCH_COMPANIES_ERROR',
  COMPANY_SET: 'company/SET_VALUE',
  COMPANY_ADD: 'company/ADD_VALUE',
  COMPANY_DEL: 'company/DEL_VALUE',
  COMPANY_SUCCESS: 'company/SUCCESS',
  COMPANY_ERROR: 'company/ERROR',
}

export default actions
